var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"s-tags",style:(_vm.listStyle)},_vm._l((_vm.tags.split(',')),function(item){return _c('span',{key:item,staticClass:"item",style:(_vm.itemStyle)},[_vm._v(_vm._s(item))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }